import {
  EventData,
  EventName,
  EventParams,
  ProviderConfig,
  ProviderType,
  User
} from './models'
import DatadogProvider from './providers/datadog'
import SegmentProvider from './providers/segment'

export default class Logger {
  private static user: User | null = null

  /**
   * Identify user and set user data
   * @param userId
   * @param traits
   */
  public static identify(userId: string, traits: User) {
    this.setUser({
      ...traits
    })
    const userData = {
      ...this.user,
      ...traits
    }

    const datadogProvider = new DatadogProvider()
    datadogProvider.identify(userId, userData)
    const segmentProvider = new SegmentProvider()
    segmentProvider.identify(userId, userData)
  }

  /**
   * Add log into providers
   * @param eventName log eventName
   * @param eventData  log eventData
   * @param providerConfig provider configuration
   * @param providerType provider type (datadog or segment), if not pass, add log to all providers by default
   */
  public static addLog(
    eventName: EventName,
    eventParams: EventParams,
    providerConfig?: ProviderConfig,
    providerTypes: ProviderType[] = [ProviderType.DATADOG, ProviderType.SEGMENT]
  ) {
    const eventData: EventData = {
      userId: this.user?.id || '',
      userRole: this.user?.role || '',
      ...eventParams
    }

    if (providerTypes.includes(ProviderType.DATADOG)) {
      const datadogProvider = new DatadogProvider()
      datadogProvider.log(eventName, eventData, providerConfig)
    }
    if (providerTypes.includes(ProviderType.SEGMENT)) {
      const segmentProvider = new SegmentProvider()
      segmentProvider.log(eventName, eventData)
    }
  }

  private static setUser(user: User) {
    this.user = user
  }

  public static removeUser() {
    this.user = null
  }
}
